export const useGetLocByIP = async () => {
  try {
    const response = await fetch('https://ipinfo.io/json?token=32121cbd8ccccd');
    globalConfig().setLocation(await response.json());
  } catch (error) {
    console.log('ERROR: Unable to fetch user IP');
  }
}
